import {Injectable} from "@angular/core";
import {Subject} from "rxjs";
import {FormBuilder, FormControl, FormGroup, ValidationErrors} from "@angular/forms";
import {AppService} from "@core/services/app.service";
import {NavService} from "@core/services/nav.service";
import {NotifyService} from "@shared/services/global/index";
import {IResponseApi} from "@core/models";
import {ERROR_CODE} from "@core/constants";


type IErrorInvalid = {
  control: FormControl,
  messageError?: string,
}

/**
 * Description handler
 * - Handler show errors common.
 * */
@Injectable({
  providedIn: "any",
})
export class AppFormAddService {
  destroyed = new Subject();
  disabledSubmit = false; // State đánh dấu disabled button submit
  takeWhile = true;
  formErrors: Record<string, string> = {}; // Lưu

  constructor(
    public appService: AppService,
    public notifyService: NotifyService,
    public navService: NavService,
    public formBuilder: FormBuilder,
  ) {

  }

  getDestroySubs() {
    this.destroyed.next(null);
    this.destroyed.complete();
  }

  /**
   * ------------------------------------------------------------------------------------------------------------------
   * Form logic handle ------------------------------------------------------------------------------------------------
   * ------------------------------------------------------------------------------------------------------------------
   * */
  createForm<T = FormGroup>(controls: T | any) {
    return this.formBuilder.group(controls) as T
  }

  setPatchValue(form: FormGroup, values: any, opts?: { onlySelf?: boolean; emitEvent?: boolean; }) {
    form.patchValue(values, opts ? opts : {
      emitEvent: false,
      onlySelf: true
    })
  }

  handlerError(res: IResponseApi<any>, form: FormGroup) {
    if (res.errorCode == ERROR_CODE.ERR_INVALID_FORM_FIELDS) {
      for (const [err, message] of Object.entries(res.messages)) {
        if (typeof form.controls[err] != 'undefined') {
          form.controls[err].setErrors({
            serverError: {message: message}
          });
        }
      }
    } else {
      this.notifyService.warning(res.messages);
    }
  }

  /**
   * - Hàm thực thi việc call api chung, hàm xử lý các logic chung như sau
   * + Start call api:
   * ++ Show loading
   * ++ Disable button
   *
   * + Complete api:
   * ++ Hide loading
   * ++ enabled button
   * */
  // fetchApiHandle<T = any>(observable: Observable<any>, typeLoading: 'spinner' | 'loading' = 'spinner') {
  // if (typeLoading === "loading") {
  // this.appService.showLoading();
  // } else {
  // this.appService.showSpinner();
  // }
  //
  // this.disabledSubmit = true;
  //
  // return observable.pipe(
  // tap({
  // complete: () => {
  // if (typeLoading === "loading") {
  // this.appService.hideLoading();
  // } else {
  // this.appService.hideSpinner();
  // }
  // this.disabledSubmit = false;
  // },
  // error: () => this.notifyService.errorSystem(),
  // })
  // ) as Observable<IResponseApi<T>>;
  // }

  /**
   * Kiểm tra có thỏa mãn các điều kiện validator của form không
   * */
  submitFromHandle(form: FormGroup): boolean {
    form.markAllAsTouched();
    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);
      if (control) {
        control.updateValueAndValidity({onlySelf: true, emitEvent: false});
      }
    });
    form.updateValueAndValidity({emitEvent: true});
    if (form.valid) {
      this.disabledSubmit = true;
      return true;
    }
    return false;
  }

  private _customMarkAllAsDirty(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      if (control instanceof FormControl) {
        control.markAsDirty();
      } else if (control instanceof FormGroup) {
        this._customMarkAllAsDirty(control);
      }
    });
  }

  private _customMarkAllAsTouched(form: FormGroup) {
    Object.keys(form.controls).forEach(controlName => {
      const control = form.get(controlName);
      if (control instanceof FormControl) {
        control.markAsTouched();
      } else if (control instanceof FormGroup) {
        this._customMarkAllAsTouched(control);
      }
    });
  }

  /**
   * @param opts.control - FormControl
   * @param opts.messageError - Key translate
   * */
  setErrorInvalid(opts: IErrorInvalid) {
    const errors: ValidationErrors = {};
    errors['invalid'] = opts.messageError ? opts.messageError : 'common.messages.invalidData';
    opts.control.setErrors(errors);
    return {
      invalid: true
    }
  }

  /**
   * Hàm xử lý reset value form
   * - Reset value kèm ẩn lỗi mặc định
   * - Thường với form dùng trên modal mà vẫn tiếp tục thêm mới thì cần reset lại value
   *
   * @param form
   * @param data
   * object chứa giá trị mặc định của các trường trong form
   * */
  resetFromHandle(form: FormGroup, data?: any) {
    this.disabledSubmit = false;
    if (data) {
      form.reset(data);
    } else {
      form.reset();
    }

    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);
      if (control) {
        control.markAsPending();
      }
    });

    form.markAsUntouched();
    form.markAsPending();
    form.updateValueAndValidity();
  }

}
